module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"download":"Download","viewer":"Open Viewer","import":"Import data","comments":"Open comments","favorite":"Favorite"},"fr":{"download":"Télécharger","viewer":"Ouvrir la visionneuse","import":"Importer des données","comments":"Ouvrir les commentaires","favorite":"Favori"}}')
  delete Component.options._Ctor
}
